import Sloth from 'slothd/dist/Sloth';
import './course.scss';

@Sloth.component({
    defaultOptions:{
        option: 'option'
    }
})

export default class course {
    onInit() {}
}



/** WEBPACK FOOTER **
 ** ./components/Course/course.js
 **/